import React from 'react';
import { Redirect, Route, type RouteProps } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { usePermission } from '@/hooks/usePermission';
import { defaultLandingPath } from '@/utils/landing';

interface ProtectedRouteProps extends RouteProps {
  /** @deprecated Use requiredPermissions instead */
  requiredRoles?: string[];
  /** Permission strings the user must have (any of them). */
  requiredPermissions?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  requiredRoles,
  requiredPermissions,
  ...routeProps
}) => {
  const { isAuthenticated, user } = useAuthStore();
  const { can, canAny } = usePermission();

  if (!isAuthenticated) {
    return <Redirect to="/login" />;
  }

  const fallback = defaultLandingPath(can);

  // Wait for user data (permissions) to load before checking
  if (requiredPermissions && requiredPermissions.length > 0) {
    if (!user) {
      // User data still loading — render nothing until /auth/me resolves
      return null;
    }
    if (!canAny(requiredPermissions)) {
      return <Redirect to={fallback} />;
    }
  }

  // Legacy role-based check (deprecated, kept for backward compat)
  if (requiredRoles && requiredRoles.length > 0 && user) {
    if (!requiredRoles.includes(user.role)) {
      return <Redirect to={fallback} />;
    }
  }

  return <Route {...routeProps} />;
};

export default ProtectedRoute;
